export const message = { dropHere: 'فایل را در این مکان رها کنید' };
